const setPhoneNumbersA2PLookup = function (state, data: any) {
  const { linkedNumbers } = data
  const lookupTable = {}
  const totalCount = linkedNumbers?.length

  // Iterate over the array and add each item to the lookup table.
  for (let index = 0; index < totalCount; ++index) {
    const item = linkedNumbers[index]
    const id = item["sid"]
    lookupTable[id] = true
  }

  state.phoneNumbersA2PLookup = {}
  state.phoneNumbersA2PLookup = lookupTable
}

export default setPhoneNumbersA2PLookup
